module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs a-form-inputs--table"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('accordion', [_c('general-damages'), _vm._v(" "), _c('past-cost-of-care'), _vm._v(" "), _c('past-cost-of-travel'), _vm._v(" "), _c('past-loss-of-earnings')], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.allValid
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55377c00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/CruBenefits.vue
// module id = 1695
// module chunks = 0